import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, inject } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { PaymentMethodTypeStore } from '@digiwall/goliath-contacts';
import {
  DocRole,
  InvoiceTermLookupDto,
  InvoiceTermService,
  PaymentTermLookupDto,
  PaymentTermService,
} from '@digiwall/goliath-core/proxy';
import { Observable, map } from 'rxjs';
import { NgxValidateCoreModule } from '@ngx-validate/core';
import { NgSelectComponent, NgOptionTemplateDirective } from '@ng-select/ng-select';
import { AutoSizedDropdownDirective, OrderByPipe } from '@digiwall/ui-kit';
import { DwInputAutoCompleteDirective, ErrorFormControlDirective } from '@digiwall/core';
import { NgxMaskDirective } from 'ngx-mask';
import { DwInputDirective } from '@digiwall/core';
import { AsyncPipe } from '@angular/common';
import { LocalizationModule } from '@abp/ng.core';

@Component({
  selector: 'document-doc-conditions',
  templateUrl: './doc-conditions.component.html',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgxValidateCoreModule,
    NgSelectComponent,
    AutoSizedDropdownDirective,
    ErrorFormControlDirective,
    NgOptionTemplateDirective,
    NgxMaskDirective,
    DwInputDirective,
    AsyncPipe,
    LocalizationModule,
    DwInputAutoCompleteDirective,
    OrderByPipe,
  ],
})
export class DocConditionsComponent implements OnInit {
  @Input() docForm: FormGroup;
  @Input() docRoleInput: DocRole;

  docRole = DocRole;

  paymentTerms$: Observable<PaymentTermLookupDto[]>;
  invoicingTerms$: Observable<InvoiceTermLookupDto[]>;

  paymentMethodTypeStore = inject(PaymentMethodTypeStore);

  constructor(
    private paymentTermService: PaymentTermService,
    private incoiceTermService: InvoiceTermService,
  ) {}

  ngOnInit(): void {
    this.paymentTerms$ = this.paymentTermService.getPaymentTermLookup().pipe(map(r => r.items));
    this.invoicingTerms$ = this.incoiceTermService.getInvoiceTermLookup().pipe(map(r => r.items));
  }
}
